import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MorningstarTotalAndPriceReturnsComponent } from './morningstar-total-and-price-returns.component';

import { MorningstarTotalAndPriceReturnsDisclosureComponent } from '../morningstar-total-and-price-returns-disclosure/morningstar-total-and-price-returns-disclosure.component';

import { SafePipe } from 'src/app/pipes/safe.pipe';



@NgModule({
  declarations: [
    MorningstarTotalAndPriceReturnsComponent,
    MorningstarTotalAndPriceReturnsDisclosureComponent
  ],
  imports: [
    CommonModule,
    SafePipe,
    // RouterModule.forChild([{
    //   path:'',component:MorningstarTotalAndPriceReturnsComponent
    // }])
  ],
  exports: [
    MorningstarTotalAndPriceReturnsComponent,
    MorningstarTotalAndPriceReturnsDisclosureComponent
  ],
})
export class MorningstarTotalAndPriceReturnsModule { }
